import type { ReactNode } from 'react';
import { List, Record } from 'immutable';
import type { RecordOf } from 'immutable';

const ModalFactory = Record({
  isOpenDocumentHotkeysModal: false,
  isOpenWorkspaceHotkeysModal: false,
});

type UiApprovalStampPositionData = { ll: List<number>; ur: List<number>; rotation: number };

/** Where the approval stamp goes on the first page: corners in the PDF page box units and the page rotation. */
export type UiApprovalStampPosition = RecordOf<UiApprovalStampPositionData>;

export const UiApprovalStampPositionFactory = Record<UiApprovalStampPositionData>({
  ll: List([0, 0]),
  ur: List([0, 0]),
  rotation: 0,
});

const ApprovalFlowFactory = Record<{ isOpen: boolean; stampPosition: UiApprovalStampPosition | null }>({
  isOpen: false,
  stampPosition: null,
});

const WorkspaceFactory = Record({
  isActiveContextMenu: false,
});

const DrawerFactory = Record({
  isOpen: false,
});

const SelectFactory = Record({
  isOpen: false,
});

type DeferredToastData = {
  type: 'success' | 'info' | 'warn' | 'error';
  /** A ready node, or a message descriptor the toast middleware formats when it shows the toast. */
  message: ReactNode | { id: string; defaultMessage?: string; values?: { [key: string]: unknown } };
};

export const DeferredToastFactory = Record<DeferredToastData>({
  type: 'success',
  message: '',
});

const ToastFactory = Record<{ deferred: List<RecordOf<DeferredToastData>> }>({
  deferred: List(),
});

const ExtractedFieldsFactory = Record({
  isHighlighted: true,
});

export const UiStateFactory = Record({
  modal: ModalFactory(),
  approvalFlow: ApprovalFlowFactory(),
  workspace: WorkspaceFactory(),
  drawer: DrawerFactory(),
  select: SelectFactory(),
  toast: ToastFactory(),
  extractedFields: ExtractedFieldsFactory(),
});
